import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvCardImage";
/**
 * A card with an image
 */
let LvCardImage = class LvCardImage extends UIComponent {
};
__decorate([
    Prop({ type: String, required: true }),
    __metadata("design:type", String)
], LvCardImage.prototype, "imageSrc", void 0);
LvCardImage = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvCardImage);
export default LvCardImage;
//# sourceMappingURL=script.js.map